export const isResidenceFeatureEnabled = () => {
    return window.config.FEATURE_RESIDENCES;
}